export default __webpack_public_path__ + "static/media/beep1c.6f4657ae.mp3";